export const MAX_NUM_COMMENTS = 2;
export const MAX_NUM_REPLIES = 1;
